import React from 'react';
import { useSticker } from '../../context/StickerContext';
import { Undo, Redo, FileText } from 'lucide-react';
export function EditorCanvas() {
  const {
    uploadedFile
  } = useSticker();
  return <div className="flex-1 bg-gray-100 relative overflow-hidden flex items-center justify-center p-12" data-id="element-54">
      {/* Undo/Redo Controls */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-white rounded-lg shadow-sm border border-gray-200 p-1 flex gap-1" data-id="element-55">
        <button className="p-2 hover:bg-gray-50 rounded text-gray-500" data-id="element-56">
          <Undo size={18} data-id="element-57" />
        </button>
        <button className="p-2 hover:bg-gray-50 rounded text-gray-500" data-id="element-58">
          <Redo size={18} data-id="element-59" />
        </button>
      </div>

      {/* Canvas Workspace */}
      <div className="w-[600px] h-[600px] bg-white shadow-lg rounded-sm relative flex items-center justify-center" data-id="element-60">
        {/* Cutline Border */}
        <div className="absolute inset-8 border-2 border-dashed border-violet-300 rounded-3xl pointer-events-none z-10" data-id="element-61" />

        {/* Content */}
        {uploadedFile ? <div className="w-3/4 h-3/4 relative" data-id="element-62">
            {uploadedFile.thumbnail ? <img src={uploadedFile.thumbnail} alt="Sticker" className="w-full h-full object-contain" data-id="element-63" /> : <div className="w-full h-full flex items-center justify-center bg-gray-50 text-gray-400" data-id="element-64">
                <FileText size={64} data-id="element-65" />
              </div>}
          </div> : <div className="text-gray-300 font-bold text-4xl" data-id="element-66">Canvas Empty</div>}
      </div>
    </div>;
}